export const errorMessageByErrorId = {
  1019: 'memberDisabledInTimespan',
};
